(() => {
  if (customElements.get('hexa-pack-selector')) return;
  class HexaPackSelector extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.scope = this.closest('.shopify-section');
      this.options = [...this.querySelectorAll('[data-hexa-pack-option]')];
      this.addEventListener('click', (event) => {
        const option = event.target.closest('[data-hexa-pack-option]');
        if (option && !option.disabled) this.select(option);
      });
      this.addEventListener('keydown', (event) => {
        const active = event.target.closest('[data-hexa-pack-option]');
        const options = this.options.filter((option) => !option.disabled);
        if (!active || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let index = options.indexOf(active);
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = options.length - 1;
        else index = (index + (['ArrowLeft', 'ArrowDown'].includes(event.key) ? 1 : -1) + options.length) % options.length;
        options[index]?.focus();
        if (options[index]) this.select(options[index]);
      });
      this.select(this.options.find((option) => option.getAttribute('aria-checked') === 'true'));
    }
    select(option) {
      if (!option || !this.scope) return;
      const form = this.scope.querySelector('product-form-component form[data-type="add-to-cart-form"]');
      const input = form?.querySelector('[name="id"]');
      if (!input) return;
      const available = option.dataset.available === 'true' && !!option.dataset.variantId;
      input.value = option.dataset.variantId;
      input.disabled = !available;
      this.options.forEach((item) => {
        const selected = item === option;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-checked', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      this.scope.querySelectorAll('product-form-component [ref="addToCartButton"], [data-hexa-quick-purchase], sticky-add-to-cart [ref="addToCartButton"]').forEach((button) => {
        button.disabled = !available;
      });
      const price = option.querySelector('template[data-hexa-selected-price]');
      this.scope.querySelectorAll('product-price[data-product-id="' + this.dataset.productId + '"] [ref="priceContainer"], sticky-add-to-cart [ref="priceContainer"]').forEach((container) => {
        if (price) container.replaceChildren(price.content.cloneNode(true));
      });
      const sticky = this.scope.querySelector('sticky-add-to-cart');
      if (sticky) {
        sticky.dataset.currentVariantId = option.dataset.variantId;
        sticky.dataset.variantAvailable = String(available);
        const label = sticky.querySelector('.sticky-add-to-cart__variant');
        if (label) {
          label.textContent = option.dataset.label;
          label.style.removeProperty('display');
        }
      }
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  customElements.define('hexa-pack-selector', HexaPackSelector);
})();
